import styled from 'styled-components';
import { Modal, Button } from '@prosolve/common-components-ui'
import useForm from '../../../../hooks/useForm'
import { FormField } from '@prosolve/common-components-ui'

const Header = styled.div`
  display: flex;
  align-items: center;
  color: #565656;
  font-weight: bold;
`

const Title = styled.div`
  font-size: 22px;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  height: 275px;
`

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  column-gap: 10px;
  padding: 10px;
`

export default ({
  onClose,
  onConfirmation,
}) => {

  const formSchema = {
    requiredFields: ['paidDate'],
    initData: { paidDate: new Date() }
  }

  const formData = useForm(formSchema)

  const onSubmit = () => {
    if (formData.isValid()) {
      onConfirmation(formData.values.paidDate)
    }
  }

  const TitleComponent = (
    <Header>
      <Title>
        {'Add Paid Date'}
      </Title>
    </Header>
  )

  const baseButtonStyle = {
    // padding: '10px',
    // fontSize: '18px',
    // borderRadius: '10px',
    width: '100px'
  }

  const FooterComponent = (
    <ButtonsContainer>
      <Button style={baseButtonStyle} onClick={onClose}>
        {'Cancel'}
      </Button>
      <Button style={{ ...baseButtonStyle, fontWeight: 'bold' }} onClick={onSubmit} $colored={true}>
        {'Paid'}
      </Button>
    </ButtonsContainer>
  )

  return (
    <Modal 
      title={TitleComponent}
      isAutoHeight={true} 
      closeOnOffClick={false}
      footer={FooterComponent} 
      onClose={onClose}
    >
      <Content>
        <FormField
          fieldId='paidDate'
          type='date'
          label='Paid Date*'
          style={{ flex: 1 }}
          formData={formData}
        />
      </Content>
    </Modal>
  )
}